module.exports = __webpack_public_path__ + "af.no1.8eaeeaf8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/okuta/child_to_parent/af.no1.jpg
// module id = cX/O
// module chunks = 0